import { DataItem } from "./panel-menu.types";
import { Breakpoints } from "../types";

export enum NavTreeActionType {
  ADD_ACTIVE = "ADD_ACTIVE",
  REPLACE_STATE = "REPLACE_STATE",
  TOGGLE_EXPAND = "TOGGLE_EXPAND",
  SET_HEADER_META_DATA = "SET_HEADER_META_DATA",
  SET_ITEMS_WIDTH = "SET_ITEMS_WIDTH",
  CLEAR_AND_START_MEASUREMENT = "CLEAR_AND_START_MEASUREMENT",
  SET_ITEMS_VISIBILITY = "SET_ITEMS_VISIBILITY",
}

interface ReplaceStateAction {
  type: NavTreeActionType.REPLACE_STATE;
  changedTree: DataItem[];
  isHeaderSecondary?: boolean;
}

interface AddActiveAction {
  type: NavTreeActionType.ADD_ACTIVE;
  itemId: string;
  isHeaderSecondary?: boolean;
}

interface ToggleExpandAction {
  type: NavTreeActionType.TOGGLE_EXPAND;
  itemId: string;
  isHeaderSecondary?: boolean;
}

interface SetHeaderMetaDataAction {
  type: NavTreeActionType.SET_HEADER_META_DATA;
  headerWidth?: number;
  customBreakpoints?: Breakpoints;
}

interface SetItemsWidthAction {
  type: NavTreeActionType.SET_ITEMS_WIDTH;
  navItemsWidth: number[];
}

interface ClearAndStartMeasurmentAction {
  type: NavTreeActionType.CLEAR_AND_START_MEASUREMENT;
}

interface SetItemsVisibilityAction {
  type: NavTreeActionType.SET_ITEMS_VISIBILITY;
  totalItemsWidth: number;
  menuContainerWidth: number;
}

export enum NavTreeType {
  PRIMARY = "navTree",
  SECONDARY = "navTreeSecondary",
}

export type NavTreeAction =
  | ReplaceStateAction
  | AddActiveAction
  | ToggleExpandAction
  | SetHeaderMetaDataAction
  | SetItemsWidthAction
  | ClearAndStartMeasurmentAction
  | SetItemsVisibilityAction;
